import Service from "../service";
import userManager from "../../userManager"

class DocumentsService extends Service {
    async get(downloadUrl) {
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Authorization": this.getAuthorizationToken()
            }
        };

        const baseURL = process.env.REACT_APP_ENVIRONMENT === 'Production' ? process.env.REACT_APP_PURCHASE_API_URI : 'http://localhost:5552';

        const response = await fetch(`${baseURL}${downloadUrl}`, requestOptions);

        if (response.status === 401) {
            userManager.signinRedirect();
        }

        if (response.status !== 200) {
            throw new Error("Произошла ошибка при скачивании файла");
        }

        const blob = await response.blob();
        return blob;
    }
}

export default new DocumentsService();
